import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { SearchBarComponent } from '@app-components/common/search-bar/search-bar.component';

@Component({
  selector: 'app-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss'],
  imports: [
    MatProgressBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    TranslateModule,
    NgxFileDropModule,
    SearchBarComponent,
    MatTooltipModule,
  ],
})
export class ImportFileComponent implements OnDestroy {
  @Input() public isLoading = false;
  @Input() public progressValue = 0;
  @Input() public textError = '';
  @Input() public filesError = '';

  @Output() closeDrawer = new EventEmitter<void>();
  @Output() fileDrop = new EventEmitter<NgxFileDropEntry[]>();
  @Output() reloadEvent = new EventEmitter<void>();
  @Output() searchEvent = new EventEmitter<string>();

  public search = '';

  onSearchValueChanged($event: string): void {
    this.search = $event;
  }

  reload(): void {
    this.search = '';
    this.reloadEvent.emit();
  }

  onDrop(event: NgxFileDropEntry[]): void {
    this.fileDrop.emit(event);
  }

  ngOnDestroy(): void {
    this.closeDrawer.emit();
  }
}
